<template>
  <div>
    <div class="card-grid p-3">
      <li style="text-align: start; margin: 4px;" class="textoSubtitulo"> Atajos</li>
      <div>
        <b-row>
          <b-col v-if="$localStorageService.can('Atajo_Nuevo_Px')">
            <b-button
                v-on:click="agregarPaciente"
                class="iconos-atajo"
            >
              <img alt="dash" class="imagen-tratamiento" width="20px" :src="require ('/src/assets/nuevoDashboard/agregar_usuario.svg')">
            </b-button>
            <p style="font-size: 13px;" class="mt-2 texto-tratamiento"><strong>Nuevo/Editar Paciente</strong></p>
          </b-col>
          <b-col v-if="$localStorageService.can('Atajo_Agenda_clinica')">
            <b-button
                v-on:click="irAgenda"
                class="iconos-atajo"
            >
            <img alt="dash" class="imagen-tratamiento" width="20px" :src="require ('/src/assets/nuevoDashboard/cita.svg')">
            </b-button>
            <p style="font-size: 13px;" class="mt-2 texto-tratamiento"><strong>Agenda Clínica</strong></p>
          </b-col>
          <b-col v-if="$localStorageService.can('Atajo_Agenda_EE')">
            <b-button
                v-on:click="irAgendaEE"
                class="iconos-atajo">
            <img alt="dash" class="imagen-tratamiento" width="20px" :src="require ('/src/assets/nuevoDashboard/agenda.svg')">
            </b-button>
            <p style="font-size: 13px;" class="mt-2 texto-tratamiento"><strong>Agenda EE</strong></p>
          </b-col>
          <b-col v-if="$localStorageService.can('Atajo_Proxima_cita')">
            <b-button
                v-on:click="irAgendaProxCitas"
                class="iconos-atajo">
              <img alt="dash" class="imagen-tratamiento" width="20px" :src="require ('/src/assets/agenda/calendar.svg')" style="filter: brightness(0) invert(1);">
            </b-button>
            <p style="font-size: 13px;" class="mt-2 texto-tratamiento"><strong>Próximas citas</strong></p>
          </b-col>
        </b-row>
      </div>
  </div>
  </div>
</template>
<script>
export default {
  methods: {
    agregarPaciente() {
      localStorage.procedencia = 1;
      this.$router.push({name: "PacienteCu"});
    },
    irAgenda() {
      this.$router.push({name: "Schedule"});
    },
    irAgendaEE(){
      this.$router.push({name: "Schedule"});
      localStorage.abrirAgendaEE = true;
    },
    irAgendaProxCitas(){
      this.$router.push({name: "Schedule"});
      localStorage.vistaProximasCitas = true;
    }
  }
}
</script>
<style scoped>
.card-grid{
  padding: 0% 0% 0% 0%;
  margin: 0% 6% 0% 3%;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);
  height: 20%;
}
.iconos-atajo{
  border-radius: 49%;
  box-shadow: 0px 10px 10px -6px black;
  background:  #1B81AF;
  border-color:  #1B81AF;
}
.iconos-atajo:hover {
  color: #fff;
  background-color: #A2DAE3;
  border-color: #A2DAE3;
}
</style>
